module.exports = __webpack_public_path__ + "static/media/image_53.0d362624.png";